
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { SidebarProvider } from "@/components/ui/sidebar";
import { DashboardSidebar } from "@/components/dashboard/DashboardSidebar";
import { AdminUsersList } from "@/components/admin/AdminUsersList";
import { AdminUsersSearch } from "@/components/admin/AdminUsersSearch";
import { supabase } from "@/lib/supabase";
import { toast } from "sonner";

export default function AdminUsers() {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(true);
  const [search, setSearch] = useState("");

  useEffect(() => {
    checkSuperuser();
  }, []);

  const checkSuperuser = async () => {
    try {
      const { data: { session } } = await supabase.auth.getSession();
      if (!session) {
        navigate("/login");
        return;
      }

      const { data: profile, error } = await supabase
        .from('profiles')
        .select('is_superuser')
        .eq('id', session.user.id)
        .single();

      if (error) throw error;

      if (!profile?.is_superuser) {
        toast.error("Unauthorized access");
        navigate("/dashboard");
        return;
      }

      setIsLoading(false);
    } catch (error) {
      console.error("Error checking superuser status:", error);
      toast.error("An error occurred");
      navigate("/dashboard");
    }
  };

  if (isLoading) {
    return <div>Loading...</div>;
  }

  return (
    <SidebarProvider>
      <div className="min-h-screen flex w-full">
        <DashboardSidebar />
        <div className="flex-1 flex flex-col">
          <Header />
          <main className="flex-1 container max-w-7xl mx-auto px-4 py-8">
            <div className="mb-8">
              <h1 className="text-3xl font-bold">User Management</h1>
              <p className="text-muted-foreground mt-2">
                Manage user accounts and permissions
              </p>
            </div>
            <AdminUsersSearch search={search} setSearch={setSearch} />
            <AdminUsersList search={search} />
          </main>
          <Footer />
        </div>
      </div>
    </SidebarProvider>
  );
}
